import * as Yup from "yup";

const newAttributeFormValidationSchema = Yup.object().shape({
  name: Yup.string().required("Attribute Name is Required"),
  category_ids: Yup.array()
    .min(1, "Category is required")
    .required("Category is required"),
  isColor: Yup.bool(),
  attr_values: Yup.array()
    .ensure()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Value is required"),
        hexCode: Yup.string().test(
          "validate-hexCode",
          "A valid Hex-code is required",
          function (value) {
            const { isColor } = this.options.context;
            if (isColor) {
              return !!value && /^#[0-9A-Fa-f]{6}$/.test(value);
            }
            return true; // Skip validation if isColor is false
          }
        ),
      })
    )
    .min(1, "At least one attribute value is required")
    .required("At least one attribute value is required"),
});

export default newAttributeFormValidationSchema;

export const newTranslationFormValidationSchema = Yup.object().shape({
  translation: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required("Required"),
    })
  ),
});
